// #======================================#
// #     _____       _ _       _  _       #
// #    |  __ \     (_) |     | || |      #
// #    | |__) |__ _ _| |___  | || |_     #
// #    |  _  // _` | | / __| |__   _|    #
// #    | | \ \ (_| | | \__ \    | |      #
// #    |_|  \_\__,_|_|_|___/    |_|      #
// #                                      #
// #======================================#

define('ExceptionHandler',function(){

  var instance = new ExceptionHandler();
  var MAX_BUFFERED_ITEMS = 10;
  var THRESHOLD_LOGGING = 5;

  function ExceptionHandler() {
    this.full_logging_enabled = false;
    this.buffered = [];
    this.threshold = 0;
    this.last_log_call_date = "page_load :"+(new Date()).toString();
  }

  ExceptionHandler.prototype.msg = function (message,backtrace) {
    var s = "location: "+window.location+"\n"
    if (backtrace) {
      s = s + backtrace;
    }
    return {
      message: message,
      backtrace : s,
      timestamp : (this.getTimestamp()).toString()
    }
  }

  ExceptionHandler.prototype.getTimestamp = function (date) {
    var d = (date || new Date());
    var serverTimeOffset = window.serverTimeOffset || 0
    return new Date(d.valueOf() + serverTimeOffset)
  }

  ExceptionHandler.prototype.setFullLoggingEnabled = function (value) {
    this.full_logging_enabled = value
    if (value === true) {
      if (this.buffered.length > 0) {
        this.logPreviousErrors(this.msg('previous errors were found after logging was enabled'));
      }
      var self = this;
      window.setTimeout(function (){
        // retry forever sending messages that were missed.
        window.setInterval(function () {
          if (self.buffered.length > 0) {
            self.logPreviousErrors(self.msg('resending buffered errors from: '+self.last_log_call_date+' until: '+(new Date()).toString()))
          }
        },10000);
      },2000);
    }

  }

  ExceptionHandler.prototype.handle_exception = function (e) {
    // report exception.
    if (e.stack && typeof console !== 'undefined' && console.log) {
      console.log(e.message);
      console.log(e.stack);
    }

    try {
      var message = this.msg(e.message,e.stack);
      this.logMessage(message)
    }
    catch(e) {
      if (typeof AUCTION_DEBUG !== 'undefined') {
        console.log("failed to log to server.")
      }
    }

  }

  /*
    this is the central function through which all messages pass.

  */
  ExceptionHandler.prototype.logMessage = function (message) {
    try {
      if (this.full_logging_enabled) {
        if (!window.navigator.onLine) {
          this.bufferMessage(message)
          this.bufferMessage(this.msg("window.navigator.onLine = false while logging"))
        }
        else if (this.placed_call_at && (new Date().valueOf() - this.placed_call_at.valueOf() < 10000)){
          this.bufferMessage(message)
        }
        else {
          // calls are only placed if 1. logging was enabled. 2. browser is not offline. 3. no calls have been made in the latest 10 seconds.
          this.logToServer(JSON.stringify(message))
        }
      }
      else {
        this.bufferMessage(message)
      }
    }
    catch(e){

    }
  }
  ExceptionHandler.prototype.logMessageWithThreshold = function(message) {
    this.threshold++ ;
    if (this.threshold >= THRESHOLD_LOGGING) {
      this.logMessage(message);
    }
  }

  ExceptionHandler.prototype.bufferMessage = function(message) {
    this.buffered.push(message)
    if (this.buffered.length > MAX_BUFFERED_ITEMS) {
      this.buffered = this.buffered.slice(this.buffered.length - MAX_BUFFERED_ITEMS)
    }
  }

  ExceptionHandler.prototype.logPreviousErrors = function (message) {
    message.previous_messages = this.buffered;
    var self = this;
    this.logToServer(JSON.stringify(message),function () {
      self.buffered = []
    });
  }

  ExceptionHandler.prototype.logToServer = function (message,callback) {
    var self = this;
    self.placed_call_at = new Date();
    jQuery.ajax({
      url: '/auction/report',
      type: 'POST',
      contentType: 'application/json',
      data: message,
      success: function() {
        self.last_log_call_date = (new Date()).toString();
        if (callback) callback();
      }
    })
  }

  ExceptionHandler.prototype.monitor_detail_page = function (detail_page,lot_id,bidding_end_time) {
    var self = this;
    self.lot_id = lot_id
    self.bidding_end_time = bidding_end_time
    self.detail_page_logging_needed = this.full_logging_enabled || ($("#counter.lot_bid_state_got_highest").length > 0)
    if (self.detail_page_logging_needed) {
      self.update_closing_lot_monitor(bidding_end_time);
    }
    detail_page.add_listener(function (message){
      if (message.name == 'current_user_bid' && message.lot_id == self.lot_id) {
        // turn logging on.
        self.detail_page_logging_needed = true;
        self.update_closing_lot_monitor(self.bidding_end_time);
      }
      if (message.name == 'prolongation' && self.lot_id == message.lot_id) {
        self.bidding_end_time = message.bidding_end_time
        self.update_closing_lot_monitor(message.bidding_end_time);
      }
      if (message.name == 'lot_closed' && self.lot_id == message.lot_id){
        window.clearTimeout(self.closing_lot_monitor);
        self.detail_page_logging_needed = false;
      }
    })
  }

  ExceptionHandler.prototype.update_closing_lot_monitor = function (bidding_end_time) {
    try {
      this.bidding_end_time = bidding_end_time;
      var serverTimeOffset = window.serverTimeOffset || 0;
      var final_time = (bidding_end_time.valueOf()) - (new Date().valueOf()) - serverTimeOffset ;
      if (final_time < 10000) return ; // risky to set up if the lot is already almost closed.
      var self = this;
      var message_details = "\n" ;
      message_details = message_details + "\nlot_id : "+$("#lot_id").val() ;
      message_details = message_details + "\nbidding_end_time: "+bidding_end_time.toString();
      message_details = message_details + "\nserverTimeOffset: "+serverTimeOffset;
      message_details = message_details + "\nbids: ";
      var bid_history = $(".cw-bid_history .bid").slice(0,3);
      if (bid_history.length > 0 ){
        for (var i = 0;i < bid_history.length ; i++) {
          var obj = bid_history.get(i);
          if (obj) {
            message_details = message_details + "\n" + obj.innerHTML;
          }
        }
      }

      window.clearTimeout(this.closing_lot_monitor);
      this.closing_lot_monitor = window.setTimeout(function () {
        if (self.detail_page_logging_needed) {
          self.logMessage(self.msg("Lot close message not received 15 seconds after lot was closed.","monitor_detail_page" + message_details))
          if (!self.full_logging_enabled) {
            // force save to server.
            self.setFullLoggingEnabled(true);
          }
        }
      },final_time + 15000)
    }
    catch (e) {

    }
  }

  ExceptionHandler.protect = function(fn) {
    return function () {
        try {
          return fn.apply(this, arguments);
        }
        catch (e) {
          instance.handle_exception(e);
          return false;
        }
    }
  }



  ExceptionHandler.instance = function () {
    return instance;
  }

  return ExceptionHandler;
})
